import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key: "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key: "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key: "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  }
];
const QueryData: any = [
  {
    param: "lat",
    value: '{{lat}}',
    required: true
  },
  {
    param: "lon",
    value: '{{lon}}',
    required: true
  },
  {
    param: "land_area (in sqm)",
    value: '{{land_area}}',
    required: false
  },
//   {
//     param: "filter",
//     value: '{{filter}} Filter value in json format e.g.',
//     code: `{
//     "parcel_uid": "",
//     "property_uid": "",
// }`,
//     required: false
//   }
]
@Component({
  selector: 'app-avm-data',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, ApiTitleComponent, ApiUIResponseComponent],
  templateUrl: './avm-data.component.html'
})
export class AvmDataComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService,
    private userService: UserService,
    private router: Router) {

  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.AvmData);
          if (!matched?.methods?.includes(HTTPMethod.GET)) {
            this.router.navigate(['/'])
          }
        },
        error: (err) => {
        }
      })
  }

  ngAfterViewInit() {

  }

  api_demo = `${environment.apiBaseUrl}${apiEndPoints.avmData}`;

  api_response = `
{
  "status": 0,
  "message": "string",
  "data": {
    "property_uid": "string",
    "land_frontage": 0,
    "land_value_midpoint": 0,
    "project_name": "string",
    "visible_area_as_ratio_of_land_area": 0,
    "land_value_lower_range": 0,
    "land_value_higher_range": 0,
    "property_build_year": "string",
    "property_age": "string",
    "number_of_bedrooms": "string",
    "number_of_bathrooms": "string",
    "number_of_square_corners": 0,
    "number_of_bevelled_corners": 0,
    "road_width": "string",
    "total_open_frontage": 0,
    "percentage_length_open": 0,
    "land_frontage_direction_orientation": [
      {
        "ne": "string"
      }
    ],
    "special_view": "string",
    "land_area": 0,
    "transaction_count": {
      "three_months": 0,
      "six_months": 0,
      "one_year": 0
    },
    "neigh_name": "string",
    "block_name": "string",
    "street_name": "string",
    "average_rate": [
      {
        "year": 0,
        "average_rate": 0
      }
    ]
  }
}`;

}
